import { render, staticRenderFns } from "./Fidelitycard.vue?vue&type=template&id=c9524022&scoped=true&"
import script from "./Fidelitycard.vue?vue&type=script&lang=js&"
export * from "./Fidelitycard.vue?vue&type=script&lang=js&"
import style0 from "./Fidelitycard.vue?vue&type=style&index=0&id=c9524022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9524022",
  null
  
)

component.options.__file = "Fidelitycard.vue"
export default component.exports